export default {
    intro: '填写空白，完成表格吧！',
};
